module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "list list-box p0002"
  }, [_c('dmenu', {
    attrs: {
      "name": "读取中",
      "dock": "Loading"
    },
    on: {
      "on-switch": function($event) {
        _vm.showtoast('loading')
      }
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "name": "操作失败",
      "dock": "Failed"
    },
    on: {
      "on-switch": function($event) {
        _vm.showtoast('failed')
      }
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "name": "警告",
      "dock": "Warm"
    },
    on: {
      "on-switch": function($event) {
        _vm.showtoast('warm')
      }
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "name": "操作成功",
      "dock": "Success"
    },
    on: {
      "on-switch": function($event) {
        _vm.showtoast('success')
      }
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "name": "纯文本",
      "dock": "Text"
    },
    on: {
      "on-switch": function($event) {
        _vm.showtoast('text')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "list-title"
  }, [_vm._v("注册调用（推荐）")]), _vm._v(" "), _c('ul', {
    staticClass: "list list-box p0002"
  }, [_c('dmenu', {
    attrs: {
      "name": "注册调用",
      "dock": "Text"
    },
    on: {
      "on-switch": function($event) {
        _vm.showtoast('reg')
      }
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "name": "注册调用二",
      "dock": "Success"
    },
    on: {
      "on-switch": function($event) {
        _vm.showtoast('reg2')
      }
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "name": "注册调用控制关闭",
      "dock": "Success"
    },
    on: {
      "on-switch": function($event) {
        _vm.showtoast('reg3')
      }
    }
  })], 1), _vm._v(" "), _c('toast', {
    ref: "loading",
    attrs: {
      "type": "loading",
      "content": "读取中"
    }
  }), _vm._v(" "), _c('toast', {
    ref: "success",
    attrs: {
      "type": "success",
      "content": "发布成功"
    }
  }), _vm._v(" "), _c('toast', {
    ref: "failed",
    attrs: {
      "type": "failed",
      "content": "操作失败"
    }
  }), _vm._v(" "), _c('toast', {
    ref: "warm",
    attrs: {
      "type": "warm",
      "content": "信息有误"
    }
  }), _vm._v(" "), _c('toast', {
    ref: "text",
    attrs: {
      "type": "text",
      "content": "纯文本提示"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e607a516!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast/demo.vue
// module id = 280
// module chunks = 10